import { User } from '../types/User'

export const isProfileIncomplete = (user: User): boolean => {
  if (user.isLeadership || user.staffAugmentation) return false

  const hasTribes = Array.isArray(user.tribes) && user.tribes.length > 0
  const hasTeams =
    Array.isArray(user.teamAllocations) && user.teamAllocations.length > 0

  return !hasTribes && !hasTeams
}
